var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAuthFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign-in",
    transform: "translate(-573.000000, -645.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(553.000000, 630.660000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(19.500000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(0.500000, 3.340000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8460693,-8.8817842e-16 L1.15393066,-8.8817842e-16 C0.516601563,-8.8817842e-16 8.8817842e-16,0.516601562 8.8817842e-16,1.15393066 L8.8817842e-16,14.8460693 C8.8817842e-16,15.4833984 0.516601563,16 1.15393066,16 L8.546875,16 L8.546875,9.8125 L6.46875,9.8125 L6.46875,7.390625 L8.546875,7.390625 L8.546875,5.60827637 C8.546875,3.54138184 9.80871581,2.41638184 11.6524658,2.41638184 C12.5355225,2.41638184 13.2944336,2.48217775 13.515625,2.51159669 L13.515625,4.671875 L12.2442627,4.671875 C11.2410889,4.671875 11.046875,5.14855956 11.046875,5.84814453 L11.046875,7.390625 L13.4453125,7.390625 L13.1328125,9.8125 L11.046875,9.8125 L11.046875,16 L14.8460693,16 C15.4833984,16 16,15.4833984 16,14.8460693 L16,1.15393066 C16,0.516601562 15.4833984,-8.8817842e-16 14.8460693,-8.8817842e-16 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAuthFacebook);
export default __webpack_public_path__ + "static/media/ic_auth_facebook.e89981fe.svg";
export { ForwardRef as ReactComponent };